/* SNZ review photos (19 Oct 2026). Uploads customer photos to Cloudinary (unsigned upload preset,
   images only, reviews folder) and writes their links into the review form's hidden contact[Photos] field.
   Photos are shrunk in the browser first (longest side 2000px, JPEG) so phone uploads stay fast.
   Submit is held while an upload is still running. */
(function () {
  if (window.__snzPhotos) return; window.__snzPhotos = 1;
  var MAX_BYTES = 15 * 1024 * 1024, EDGE = 2000;

  function shrink(file) {
    return new Promise(function (ok) {
      if (!/^image\//.test(file.type) || /gif$/.test(file.type)) return ok(file);
      var url = URL.createObjectURL(file), img = new Image();
      img.onload = function () {
        var s = Math.min(1, EDGE / Math.max(img.naturalWidth, img.naturalHeight));
        if (s === 1 && file.size < 2.5 * 1024 * 1024 && /jpe?g$/.test(file.type)) { URL.revokeObjectURL(url); return ok(file); }
        var c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * s); c.height = Math.round(img.naturalHeight * s);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
        URL.revokeObjectURL(url);
        c.toBlob(function (b) { ok(b ? new File([b], (file.name || 'photo').replace(/\.\w+$/, '') + '.jpg', { type: 'image/jpeg' }) : file); }, 'image/jpeg', 0.86);
      };
      img.onerror = function () { URL.revokeObjectURL(url); ok(file); };
      img.src = url;
    });
  }

  function upload(cloud, preset, file, onProgress) {
    return new Promise(function (ok, fail) {
      var fd = new FormData();
      fd.append('upload_preset', preset);
      fd.append('file', file, file.name || 'photo.jpg');
      var x = new XMLHttpRequest();
      x.open('POST', 'https://api.cloudinary.com/v1_1/' + encodeURIComponent(cloud) + '/image/upload');
      x.upload.onprogress = function (e) { if (e.lengthComputable) onProgress(e.loaded / e.total); };
      x.onload = function () {
        try { var r = JSON.parse(x.responseText); if (x.status < 300 && r.secure_url) return ok(r.secure_url); } catch (e) {}
        fail(new Error('upload ' + x.status));
      };
      x.onerror = function () { fail(new Error('network')); };
      x.send(fd);
    });
  }

  function init(box) {
    if (box.dataset.wired) return; box.dataset.wired = '1';
    var cloud = box.dataset.cloud, preset = box.dataset.preset, max = +box.dataset.max || 3;
    var input = box.querySelector('[data-snzr-photo-input]'), list = box.querySelector('[data-snzr-thumbs]');
    var field = box.querySelector('[data-snzr-photo-urls]'), msg = box.querySelector('[data-snzr-photo-msg]');
    var form = box.closest('form'), items = [], busy = 0;

    function sync() {
      field.value = items.filter(function (i) { return i.url; }).map(function (i) { return i.url; }).join('\n');
      var btn = form.querySelector('[type=submit]');
      if (btn) { btn.disabled = busy > 0; btn.setAttribute('aria-busy', busy > 0 ? 'true' : 'false'); }
      box.querySelector('.snzr__photos-add').hidden = items.length >= max;
    }
    function say(t) { msg.textContent = t || ''; }

    input.addEventListener('change', function () {
      var files = Array.prototype.slice.call(input.files || []);
      input.value = '';
      say('');
      var room = max - items.length;
      if (files.length > room) say('Up to ' + max + ' photos per review.');
      files.slice(0, room).forEach(function (f) {
        if (f.size > MAX_BYTES) return say('That photo is too large (15 MB max).');
        var li = document.createElement('li'), it = { li: li, url: '' };
        var prev = URL.createObjectURL(f);
        li.className = 'snzr__thumb is-busy';
        li.innerHTML = '<img alt=""><span class="snzr__bar"><span></span></span><button type="button" class="snzr__rm" aria-label="Remove photo">&times;</button>';
        li.querySelector('img').src = prev;
        li.querySelector('.snzr__rm').addEventListener('click', function () {
          items = items.filter(function (i) { return i !== it; }); li.remove(); URL.revokeObjectURL(prev); sync();
        });
        list.appendChild(li); items.push(it); busy++; sync();
        shrink(f).then(function (small) {
          return upload(cloud, preset, small, function (p) { li.querySelector('.snzr__bar span').style.width = Math.round(p * 100) + '%'; });
        }).then(function (url) {
          it.url = url;
          li.classList.remove('is-busy');
        }).catch(function () {
          li.remove(); items = items.filter(function (i) { return i !== it; });
          say('A photo could not be uploaded. Please try again, or email it to us after sending.');
        }).then(function () { busy--; sync(); });
      });
    });

    form.addEventListener('submit', function (e) { if (busy > 0) { e.preventDefault(); say('Please wait for your photos to finish uploading.'); } });
    sync();
  }

  function run() { document.querySelectorAll('[data-snzr-photos]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.snzr__write')) setTimeout(run, 0); });
})();
